import { useState, useEffect } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import MaterialTypography from "../../components/MaterialTypography";
import { Card, CardHeader, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { apicall } from "../Integration/apicall";
import { getallbranch, getbranch } from "./query";
import Swal from "sweetalert2";
import { useUserDetails } from "../../context/auth";

//CSS for material UI Badge

const Allbranches = () => {
  const navigate = useNavigate();
 const { AccessData } = useUserDetails();
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [branches, setbranches] = useState([]);

  useEffect(() => {
    fetchallbranch();
  }, []);

  const fetchallbranch = async () => {
    apicall(getallbranch)
      .then((res) => {
        const message = res.data.data.getAllBranch.message;
        if (res.data.data.getAllBranch.success) {
          setbranches(res.data.data.getAllBranch.branch);
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: message,
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            navigate("/branch");
          });
        }
      })
      .catch((res) => {
        Swal.fire({
          position: "center",
          icon: "error",
          title: res.error.message,
          showConfirmButton: false,
          timer: 2500,
        }).then(() => {
          navigate("/branch");
        });
      });
  };

  const branchtable = {
    columns: [
      {
        field: "branchName",
        headerName: "Branch Name",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "branchCode",
        headerName: "Branch Code",
        width: 150,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "address1",
        headerName: "Address",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "state",
        headerName: "State",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "city",
        headerName: "City",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "country",
        headerName: "Country",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],

    rows: branches,
  };

  const Addbranch = () => {
    // setEmpSubmit(false)

    navigate("/branch/add-branch", { state: { type: "add" } });
  };

  const onbranchclick = (e) => {
    console.log("eeeee:", e);
    // setEmpSubmit(true)
    console.log("onbranchclick:", e?.id, e);
    if (e?.id) {
      navigate("/branch/add-branch", {
        state: { type: "view", branchid: e.id },
      });
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Branch List
                </MaterialTypography>
              </Stack>

             {AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) =>
                  (item.component === "AddBranch") &&
                  item.can_access
              ) && <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => Addbranch()}
              >
                Branch
              </MaterialButton>}
            </Stack>
          }
        />
        <MaterialDataGrid
          customHeight={500}
          rows={branchtable.rows}
          columns={branchtable.columns}
          checkboxSelection={false}
          isSelectable={true}
          onRowClick={onbranchclick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No branch found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any branch details. Click on the "Add
                  branch" button to start adding branch details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default Allbranches;
